import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds';
import { Box } from '@cp/ds/src/components/box';
import { Switch } from '@cp/ds/src/components/switch';
import { Typography } from '@cp/ds/src/components/typography';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { SxProps } from '@cp/ds/src/theme';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';

export type ModerationToggleVariant = 'default' | 'compact';

export interface ModerationToggleProps {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  variant?: ModerationToggleVariant;
  sx?: SxProps;
}

export const ModerationToggle = ({ label, checked, disabled, onChange, variant = 'default', sx }: ModerationToggleProps) => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  if (variant === 'compact') {
    return (
      <Box
        sx={mergeSx(
          {
            display: 'flex',
            alignItems: 'center',
            width: 1,
            minHeight: 36,
            boxSizing: 'border-box',
            backgroundColor: 'background.default',
            borderRadius: '12px',
            border: `1px solid ${theme.palette['gray light']}`,
            p: 1,
          },
          sx,
        )}
      >
        <Switch disabled={disabled} label={label} onChange={onChange} sx={{ width: 'auto' }} value={checked} />
      </Box>
    );
  }

  return (
    <Box
      sx={mergeSx(
        {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', [MOBILE_BREAKPOINT_THRESHOLD]: 'center' },
          backgroundColor: 'background.default',
          borderRadius: '12px',
          border: `1px solid ${theme.palette['gray light']}`,
          overflow: 'hidden',
          p: isMobile ? 1.5 : 2,
        },
        sx,
      )}
    >
      <Typography>{label}</Typography>
      <Switch disabled={disabled} onChange={onChange} sx={{ flex: '0 0 0px', width: 'auto' }} value={checked} />
    </Box>
  );
};
